import { debounce } from '@material-ui/core';
import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { GENERIC_ERROR_MESSAGE, getPageFromObject } from '@roc/feature-utils';
import { action, flow, makeObservable, observable, override } from 'mobx';
import { EntityStore } from './entityStore';
import { QuoteService } from '../../services/quoteService';

const PAGE_SIZE = 20;

export class SearchEntityGridStore extends GridStore {
  private globalStore: GlobalStore;
  private entityStore: EntityStore;
  private quoteService: QuoteService;

  entities: any[] = [];
  searchString = '';

  fetchGridDataDebounced = debounce(() => this.fetchGridData());

  constructor(globalStore: GlobalStore, entityStore: EntityStore) {
    super(() => this.fetchPage(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.entityStore = entityStore;
    this.quoteService = new QuoteService();

    makeObservable(this, {
      searchString: observable,
      reset: override,
      setSearchString: action,
      fetchEntities: flow,
    });
  }

  reset() {
    super.reset();
    this.entities = [];
    this.searchString = '';
    this.gridData.meta.pageSize = PAGE_SIZE;
  }

  *fetchEntities() {
    try {
      this.reset();
      const response = yield this.quoteService.getAllBorrowerEntities();
      this.entities = response.data.data.rows;
      this.fetchGridData();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  setSearchString(searchString) {
    this.searchString = searchString;
    this.fetchGridDataDebounced();
  }

  fetchPage = async () => {
    const rows = this.entities
      .map(entity => ({
        borrowerEntityId: entity.borrowerEntityId,
        companyName: entity.company?.name || '',
        borrowers: entity.borrowers.map(borrower => ({
          borrowerName: `${borrower.borrower.firstName} ${borrower.borrower.lastName}`,
          ownership: borrower.pctOwnership,
        })),
      }))
      .filter(row =>
        row.borrowers
          .map(b => b.borrowerName)
          .concat(row.companyName)
          .some(s =>
            s
              .toLocaleLowerCase()
              .includes(this.searchString.toLocaleLowerCase())
          )
      );
    const data = getPageFromObject(rows, this.gridData.meta);
    return new ApiResponse({ data }, null);
  };
}
